import styled from 'styled-components'
import { media, mediaMax } from '../../../styles/media'

import { MobileListingSliderWrapper } from '../Header/MobileListingSlider'
import { DesktopListingHeaderWrapper } from '../Header/DesktopListingHeader'
import { ListingStoryCardWrapper } from '../../../components/cards/ListingStoryCard'
import { MobileActionBarWrapper } from '../Booking/MobileActionBar'

export const ListingWrapper = styled.div`
  ${MobileListingSliderWrapper} {
    margin-bottom: 16px;
  }

  ${MobileActionBarWrapper} {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;

    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.12);
  }

  ${mediaMax.md`
    ${DesktopListingHeaderWrapper} {
      display: none;
    }
  `}

  ${media.md`
    ${MobileListingSliderWrapper} {
      display: none;
    }
  `}

  ${media.lg`
    ${MobileActionBarWrapper} {
      display: none;
    }
  `}
`

export const ContentWrapper = styled.div`
  ${ListingStoryCardWrapper} {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const Section = styled.section`
  padding: 40px 0;
  border-bottom: 1px solid #d1d1d1;

  ${media.md`
    padding: 56px 0;
  `}

  ${({ borderTop }) =>
    borderTop &&
    `
    border-top: 1px solid #d1d1d1;
    border-bottom: 0;
  `}

  ${({ noBorder }) =>
    noBorder &&
    `
    border: none;
  `}

  &:last-child {
    border: none;
  }
`

export const SubSection = styled.div`
  margin-bottom: 40px;

  ${({ intro }) =>
    intro &&
    `
    font-size: 20px;
  `}

  ${({ lessMargin }) =>
    lessMargin &&
    `
    margin-bottom: 24px;
  `}

  ${({ moreMargin }) =>
    moreMargin &&
    `
    margin-bottom: 56px;
  `}
`

export const ListingTitle = styled.h1`
  font-size: 32px;
  margin-bottom: 0.8em;

  color: ${({ theme }) => theme.brand.forest};

  ${media.md`
    font-size: 50px;
  `}
`

export const SectionTitle = styled.h2`
  font-size: 32px;
  line-height: 1.2;

  margin: 0;
  margin-bottom: 0.8em;

  color: ${({ theme }) => theme.brand.forest};
`

export const SectionSubtitle = styled.h3`
  font-size: 20px;
  line-height: 1.1;

  margin: 0;
  margin-bottom: 0.8em;

  color: ${({ theme }) => theme.brand.forest};
`

export const InfoWithIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.brand.jungle};
  margin-right: 20px;

  a {
    color: inherit;
  }

  .icon {
    color: inherit;
    margin-right: 14px;
    font-size: 24px;
  }
`

export const MapWrapper = styled.div`
  height: 360px;
`
